module.exports = __webpack_public_path__ + "img/65.b59d9187.jpg";